module.exports = __webpack_public_path__ + "img/logo-header.abde242c.svg";